import moment from "moment";
import { useEffect, useRef, useState} from "react";
import Modal from "react-modal";
import {
	useMutation,
	useQueryClient
} from "react-query";
import { Link } from "react-router-dom";
import { httpDELETE, httpGET } from "../../utils/ajaxHelper";
import DeleteConfirmModal from "./deleteConfirmModal";
import DeleteSuccessModal from "./deleteSuccess";
import { AGButton, AGButtonPrimary, CloseIcon } from "./style";
import { ArrowDownIcon } from "../../assets/svg/arrowDown";
import { ArrowUpIcon } from "../../assets/svg/arrowUp";
import { ArrowDownGrayIcon } from "../../assets/svg/arrowDownGrayIcon";
import { PageContainerContext} from "../../Provider";
import { SORT_FIELDS_OFFERING_DETAIL_ADMIN } from "../../utils/constant";
import { LoadingIcon } from "../../assets/svg/loadingIcon";

export interface CustomModalProps {
	visible: boolean;
	toggleModal: () => void;
	selectedFirm: string;
	setServiceId?: (e: number,f: number) => void;
	publishCompleted?: boolean;
	deleteServiceCompeleted?: boolean;
	updateFirmList?: (serviceId: string)=> void;
	resetSelectedFirm?: ()=> void;
	updatedFirmInfo? : any;
}
const CustomModal = ({
	visible,
	toggleModal,
	selectedFirm,
	setServiceId,
	publishCompleted,
	deleteServiceCompeleted,
	updateFirmList,
	resetSelectedFirm,
	updatedFirmInfo,
}: CustomModalProps) => {
	const queryClient = useQueryClient();
	const componentRef = useRef<HTMLDivElement>(null);
	const modalContentRef = useRef<HTMLDivElement>(null);

	const handleClose = () => {
		setSortParam({
		field: SORT_FIELDS_OFFERING_DETAIL_ADMIN.OFFERING_TYPE,
		order: 1
		});
		setExpertiseServices([]);
		if (resetSelectedFirm){
			resetSelectedFirm();
		}
		toggleModal();
	};

	const [screenWidth, setScreenWidth] = useState(window.innerWidth);
	const [deleteSuccess, setDeleteSuccess] = useState(false);
	const [expertiseServices, setExpertiseServices] = useState<any[]>([]);

	const [sortParam, setSortParam] = useState({
		field: SORT_FIELDS_OFFERING_DETAIL_ADMIN.OFFERING_TYPE,
		order: 1
	});

	const [searchParams, setSearchParams] = useState({
		field: SORT_FIELDS_OFFERING_DETAIL_ADMIN.OFFERING_TYPE,
		order: 1
	});

	useEffect(() => {
		const handleResize = () => {
			setScreenWidth(window.innerWidth);
		};

		window.addEventListener("resize", handleResize);

		return () => {
			window.removeEventListener("resize", handleResize);
		};
	}, []);
	const [useLargerStyle, setUseLargerStyle] = useState(false);
	const customStyles = {
		content: {
			top: "50%",
			left: "50%",
			right: "auto",
			bottom: "auto",
			marginRight: "-50%",
			transform: "translate(-50%, -50%)",
			borderRadius: 10,
			padding: "20px 20px 0px ",
			width: screenWidth < 1200 ? "90%" : 1300,
			fontFamily:
				"Roboto, Nunito, Arial, Helvetica, sans-serif, Arial, sans-serif",
		},
	};

	const customStylesScreenWidthLarger = {
	content: {
		top: "115px",
		left: "50%",
		right: "auto",
		bottom: "auto",
		transform: "translateX(-50%)",
		borderRadius: 10,
		padding: "0px 20px 0px",
		width: screenWidth < 1200 ? "90%" : 1300,
		fontFamily:
			"Roboto, Nunito, Arial, Helvetica, sans-serif, Arial, sans-serif",
		}	 as React.CSSProperties,
	};

	const handleAfterOpen = () => {
		if (expertiseServices) {

			if (expertiseServices?.length > 14) {
				setUseLargerStyle(true);
			} else {
				setUseLargerStyle(false);
			}
		}
	};

	const { mutate: getServices, isLoading: isSearchServiceByFirmLoading} = useMutation(
		(params: any) =>
			httpGET({
				url: "/ExpertiseService/search-by-firm",
				params: {
					firmId: selectedFirm,
					sortField: params?.field,
					sortOrder: params?.order
				}
			}),
		{
			onSuccess: (rs) => {
				setExpertiseServices(rs);
			},
		},
	);
	
	const { mutate: deleteService, } = useMutation(
		(serviceID: string) =>
			httpDELETE({
				url: "/ExpertiseService/delete",
				params: {
					comFirmDataId: serviceID
				}
			}),
		{
			onSuccess: (rs) => {
				setExpertiseServices((prev: any[]) =>
					prev?.filter(item => item.conFirmDataID !== rs.deletedId)
				);
				updateFirmList?.(selectedService);
				toggleDeleteSuccess();
			},
		},
	);
	const toggleDeleteSuccess = () => setDeleteSuccess(!deleteSuccess);
	const [openConfirm, setOpenConfirm] = useState(false);
	const [selectedService, setSelectedService] = useState("");
	const [handleText, setHandleText] = useState("");
	const toggleOpenConfirm = () => setOpenConfirm(!openConfirm);

	const movePageToTop = ()=>{
		modalContentRef?.current?.scrollTo({ top: 0, behavior: "auto" });
	}

	useEffect(() => {
		if (selectedFirm){
			getServices(searchParams)
		}
	}, [publishCompleted, deleteServiceCompeleted, searchParams, selectedFirm, getServices])

	useEffect(() => {
		if (updatedFirmInfo){
			setExpertiseServices(prev => {
			const updated = prev.map(service =>
				service.conFirmDataID === updatedFirmInfo.comOfferingId
				  ? {
					  ...service,
					  lastUpdatedDate: updatedFirmInfo.lastUpdate
					}
				  : service
			  );
		
			if (sortParam.field === SORT_FIELDS_OFFERING_DETAIL_ADMIN.LAST_UPDATED_DATE && sortParam.order === 0) {
			  return [...updated].sort(
				(a, b) => new Date(a.lastUpdatedDate).getTime() - new Date(b.lastUpdatedDate).getTime()
			  );
			}
		
			if (sortParam.field === SORT_FIELDS_OFFERING_DETAIL_ADMIN.LAST_UPDATED_DATE && sortParam.order === 1) {
			  return [...updated].sort(
				(a, b) => new Date(b.lastUpdatedDate).getTime() - new Date(a.lastUpdatedDate).getTime()
			  );
			}
		
			return updated;
		  });
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [updatedFirmInfo])

	useEffect(() => {
		if (expertiseServices) {
			setUseLargerStyle(expertiseServices.length > 14);
		}
	}, [expertiseServices]);

	const handleTextByOfferingTypeID = (id: number, type?: string) => {
		switch (id) {
			case 1:
				return "service";
			case 2:
				return "product";
			case 3:
				return "secondment";
			default:
				return "";
		}
    }

	return (
		<div ref={componentRef}>
		<Modal
			isOpen={visible}
			style={useLargerStyle ? customStylesScreenWidthLarger : customStyles}
			contentLabel="Example Modal"
			onAfterOpen={handleAfterOpen}
			contentRef={(node) => {
			(modalContentRef as React.MutableRefObject<HTMLDivElement | null>).current = node;
			}}
		>
			
				<DeleteSuccessModal
					visible={deleteSuccess}
					toggleModal={toggleDeleteSuccess}
					text={handleText}
				/>
				<DeleteConfirmModal
					visible={openConfirm}
					toggleModal={toggleOpenConfirm}
					selectedService={selectedService}
					deleteService={deleteService}
					text={handleText}
				/>
				<div className="sticky top-0 z-[100] bg-white">
				<div className={`pb-[5px] mb-[15px] ${useLargerStyle ? 'pt-[20px]': 'pt-0'}`}>
					<CloseIcon onClick={handleClose}>✖</CloseIcon>
					<div
						style={{
							fontSize: 16,
							fontWeight: 600
						}}>
						View Offering(s)
					</div>
				</div>
				<div className={`flex items-center px-3 rounded-lg pt-[5px] ${useLargerStyle ? `w-[calc(100%-8px)]` : `w-[100%]`}`}>
					<div
					onClick={() =>{
						movePageToTop();
						if (sortParam.field !== SORT_FIELDS_OFFERING_DETAIL_ADMIN.OFFERING_TYPE){
							setSortParam({
								...sortParam,
								order: 0,
								field: SORT_FIELDS_OFFERING_DETAIL_ADMIN.OFFERING_TYPE,
							});
							setSearchParams({
								...sortParam,
								order: 0,
								field: SORT_FIELDS_OFFERING_DETAIL_ADMIN.OFFERING_TYPE,
							});
						}else{
							setSortParam({
								...sortParam,
								order: sortParam.order === 1 ? 0 : 1,
								field: SORT_FIELDS_OFFERING_DETAIL_ADMIN.OFFERING_TYPE,
							});
							setSearchParams({
								...sortParam,
								order: sortParam.order === 1 ? 0 : 1,
								field: SORT_FIELDS_OFFERING_DETAIL_ADMIN.OFFERING_TYPE,
							});
						}
					}}
					className="flex-[2] text-[14px] text-submit border-solid border border-light-gray-500 py-2 px-2 font-bold  text-left">
						Offerings Type &nbsp;{" "}
						{sortParam.field === SORT_FIELDS_OFFERING_DETAIL_ADMIN.OFFERING_TYPE &&
							sortParam.order === 0 && (
								<ArrowUpIcon/>
							)}
						{sortParam.field === SORT_FIELDS_OFFERING_DETAIL_ADMIN.OFFERING_TYPE &&
							sortParam.order === 1 && (
								<ArrowDownIcon/>
							)}
						{sortParam.field !== SORT_FIELDS_OFFERING_DETAIL_ADMIN.OFFERING_TYPE && (
							<ArrowDownGrayIcon/>
						)}
					</div>
					<div
					onClick={() =>{
						movePageToTop();
						if (sortParam.field !== SORT_FIELDS_OFFERING_DETAIL_ADMIN.OFFERING_NAME){
							setSortParam({
								...sortParam,
								order: 0,
								field: SORT_FIELDS_OFFERING_DETAIL_ADMIN.OFFERING_NAME,
							});
							setSearchParams({
								...sortParam,
								order: 0,
								field: SORT_FIELDS_OFFERING_DETAIL_ADMIN.OFFERING_NAME,
							});
						}else{
							setSortParam({
								...sortParam,
								order: sortParam.order === 1 ? 0 : 1,
								field: SORT_FIELDS_OFFERING_DETAIL_ADMIN.OFFERING_NAME,
							});
							setSearchParams({
								...sortParam,
								order: sortParam.order === 1 ? 0 : 1,
								field: SORT_FIELDS_OFFERING_DETAIL_ADMIN.OFFERING_NAME,
							});
						}
					}}
					className="flex-[7] text-[14px] text-submit border-solid border border-light-gray-500 py-2 px-2 font-bold  text-left">
						Offerings Name &nbsp;{" "}
						{sortParam.field === SORT_FIELDS_OFFERING_DETAIL_ADMIN.OFFERING_NAME &&
							sortParam.order === 0 && (
								<ArrowUpIcon/>
							)}
						{sortParam.field === SORT_FIELDS_OFFERING_DETAIL_ADMIN.OFFERING_NAME &&
							sortParam.order === 1 && (
								<ArrowDownIcon/>
							)}
						{sortParam.field !== SORT_FIELDS_OFFERING_DETAIL_ADMIN.OFFERING_NAME && (
							<ArrowDownGrayIcon/>
						)}
					</div>
					<div
					onClick={() =>{
						movePageToTop();
						if (sortParam.field !== SORT_FIELDS_OFFERING_DETAIL_ADMIN.REGION){
							setSortParam({
								...sortParam,
								order: 0,
								field: SORT_FIELDS_OFFERING_DETAIL_ADMIN.REGION,
							});
							setSearchParams({
								...sortParam,
								order: 0,
								field: SORT_FIELDS_OFFERING_DETAIL_ADMIN.REGION,
							});
						}else{
							setSortParam({
								...sortParam,
								order: sortParam.order === 1 ? 0 : 1,
								field: SORT_FIELDS_OFFERING_DETAIL_ADMIN.REGION,
							});
							setSearchParams({
								...sortParam,
								order: sortParam.order === 1 ? 0 : 1,
								field: SORT_FIELDS_OFFERING_DETAIL_ADMIN.REGION,
							});
						}
					}}
					className="flex-[1.8] text-[14px] border border-light-gray-500 py-2 px-2 font-bold  text-left">
						Region &nbsp;{" "}
						{sortParam.field === SORT_FIELDS_OFFERING_DETAIL_ADMIN.REGION &&
							sortParam.order === 0 && (
								<ArrowUpIcon/>
							)}
						{sortParam.field === SORT_FIELDS_OFFERING_DETAIL_ADMIN.REGION &&
							sortParam.order === 1 && (
								<ArrowDownIcon/>
							)}
						{sortParam.field !== SORT_FIELDS_OFFERING_DETAIL_ADMIN.REGION && (
							<ArrowDownGrayIcon/>
						)}
					</div>
					<div
					onClick={() =>{
						movePageToTop();
						if (sortParam.field !== SORT_FIELDS_OFFERING_DETAIL_ADMIN.CREATED_DATE){
							setSortParam({
								...sortParam,
								order: 0,
								field: SORT_FIELDS_OFFERING_DETAIL_ADMIN.CREATED_DATE,
							});
							setSearchParams({
								...sortParam,
								order: 0,
								field: SORT_FIELDS_OFFERING_DETAIL_ADMIN.CREATED_DATE,
							});
						}else{
							setSortParam({
								...sortParam,
								order: sortParam.order === 1 ? 0 : 1,
								field: SORT_FIELDS_OFFERING_DETAIL_ADMIN.CREATED_DATE,
							});
							setSearchParams({
								...sortParam,
								order: sortParam.order === 1 ? 0 : 1,
								field: SORT_FIELDS_OFFERING_DETAIL_ADMIN.CREATED_DATE,
							});
						}
					}}
					className="flex-[2] text-[14px] border border-light-gray-500 py-2 px-2 font-bold  text-left">
						Created Date &nbsp;{" "}
						{sortParam.field === SORT_FIELDS_OFFERING_DETAIL_ADMIN.CREATED_DATE &&
							sortParam.order === 0 && (
								<ArrowUpIcon/>
							)}
						{sortParam.field === SORT_FIELDS_OFFERING_DETAIL_ADMIN.CREATED_DATE &&
							sortParam.order === 1 && (
								<ArrowDownIcon/>
							)}
						{sortParam.field !== SORT_FIELDS_OFFERING_DETAIL_ADMIN.CREATED_DATE && (
							<ArrowDownGrayIcon/>
						)}
					</div>
					<div
					onClick={() =>{
						movePageToTop();
						if (sortParam.field !== SORT_FIELDS_OFFERING_DETAIL_ADMIN.LAST_UPDATED_DATE){
							setSortParam({
								...sortParam,
								order: 0,
								field: SORT_FIELDS_OFFERING_DETAIL_ADMIN.LAST_UPDATED_DATE,
							});
							setSearchParams({
								...sortParam,
								order: 0,
								field: SORT_FIELDS_OFFERING_DETAIL_ADMIN.LAST_UPDATED_DATE,
							});
						}else{
							setSortParam({
								...sortParam,
								order: sortParam.order === 1 ? 0 : 1,
								field: SORT_FIELDS_OFFERING_DETAIL_ADMIN.LAST_UPDATED_DATE,
							});
							setSearchParams({
								...sortParam,
								order: sortParam.order === 1 ? 0 : 1,
								field: SORT_FIELDS_OFFERING_DETAIL_ADMIN.LAST_UPDATED_DATE,
							});
						}
					}}
					className="flex-[2.2] text-[14px] border border-light-gray-500 py-2 px-2 font-bold  text-left">
						Last Updated Date &nbsp;{" "}
						{sortParam.field === SORT_FIELDS_OFFERING_DETAIL_ADMIN.LAST_UPDATED_DATE &&
							sortParam.order === 0 && (
								<ArrowUpIcon/>
							)}
						{sortParam.field === SORT_FIELDS_OFFERING_DETAIL_ADMIN.LAST_UPDATED_DATE &&
							sortParam.order === 1 && (
								<ArrowDownIcon/>
							)}
						{sortParam.field !== SORT_FIELDS_OFFERING_DETAIL_ADMIN.LAST_UPDATED_DATE && (
							<ArrowDownGrayIcon/>
						)}
					</div>
					<div className="flex-[2] text-[14px] border border-light-gray-500 py-2 px-2 font-bold  text-left">
						Action
					</div>
				</div>
				</div>
				
				<div
					style={{
						width: "100%",
						textAlign: "right",
						paddingBottom: "20px"
					}}>

					{isSearchServiceByFirmLoading ? 
					<>
					<div className="flex flex-row px-[20px] py-[5px] justify-center border-t-[1px]">
					  <LoadingIcon
						width={60}
						height={60}
					  />
					</div>
					</> 
					: <>
					<div className="custom-scroll" style={{overflowY: "auto", maxHeight: "calc(100vh - 375px)"}}>
						{expertiseServices && expertiseServices?.length ? (
							expertiseServices?.map((expertiseService: any) => (
								<div
									className=" flex items-center px-3 rounded-lg"
									key={expertiseService.conFirmDataID}>
									<div className="h-10 flex-[2] text-[14px] border-solid border border-light-gray-500 py-2 px-2  text-left">
										{expertiseService.offeringTypeName}
									</div>
									<div className="h-10 flex-[7] text-[14px] text-submit border-solid border border-light-gray-500 py-2 px-2 text-blue-700 text-left">
										<Link
											className="underline"
											to={
												`/commerceProfile/${expertiseService.firmID}?tab=${handleTextByOfferingTypeID(expertiseService.offeringTypeID)}&serviceId=${expertiseService.conFirmDataID}`
											}
											target="_blank"
										>
											{expertiseService.serviceName}
										</Link>
										{expertiseService.isDraft ? <span className="text-[#58585B]"> (Draft)</span> : null}
										{expertiseService.offeringStatusName ? <span className="text-[#58585B]"> ({expertiseService.offeringStatusName})</span> : null}
									</div>
									<div className="h-10 flex-[1.8] text-[14px] border-solid border border-light-gray-500 py-2 px-2  text-left">
										{expertiseService.region}
									</div>
									<div className="h-10 flex-[2] text-[14px] border-solid border border-light-gray-500 py-2 px-2  text-left">
										{moment(expertiseService.createdDate).format(
											"MM/DD/YYYY",
										)}
									</div>
									<div className="h-10 flex-[2.2] text-[14px] border-solid border border-light-gray-500 py-2 px-2  text-left">
										{moment(expertiseService.lastUpdatedDate).format(
											"MM/DD/YYYY",
										)}
									</div>
									<div className=" h-10 flex-[2] text-[14px] border-solid border border-light-gray-500 py-2 px-2 text-left flex justify-center">
										<AGButtonPrimary
											onClick={() => {
												setServiceId && setServiceId(expertiseService.conFirmDataID,expertiseService.offeringTypeID)
												setSelectedService(expertiseService.conFirmDataID)
											}}>
											Edit
										</AGButtonPrimary>
										<AGButton
											onClick={() => {
												toggleOpenConfirm();
												setSelectedService(expertiseService.conFirmDataID,);
												setHandleText(handleTextByOfferingTypeID(expertiseService.offeringTypeID));
											}}
											style={{ background: "#D9D9D9 " }}>
											Delete
										</AGButton>
									</div>
								</div>
							))
						) : (
							<div className="text-sm	mx-3 pb-5 text-center pt-6 border-solid border border-light-gray-500">
								No Offerings found.
							</div>
						)}
					</div>
					</>}
					
				</div>
			
		</Modal>
		</div>
	);
};

export default CustomModal;
